@if (resolvedUrl$ | async; as url) {
  @if (shouldRenderWatermarkAsClass()) {
    <i [ngClass]="watermarkClass" [matTooltip]="tooltip" matTooltipShowDelay="500"></i>
  } @else if (renderAsBackground || renderAsWatermark) {
    <i [class]="imgClass" [ngStyle]="getBackgroundStyle(url)"
       [matTooltip]="tooltip" matTooltipShowDelay="500"></i>
  } @else {
    <img [class]="imgClass" [src]="url" [ngStyle]="colorStyle"
         [matTooltip]="tooltip" matTooltipShowDelay="500" alt=""
         (error)="onError()" />
  }
} @else if (resolvedIconClass) {
  <i [ngClass]="renderAsWatermark ? watermarkClass : resolvedIconClass" [matTooltip]="tooltip" matTooltipShowDelay="500"></i>
}
